<template>
  <div class="uk-container login-user">
    <div class="uk-margin-top uk-margin-bottom">
      <a href="https://ucari.com/">
          <img src="/images/logo.png" alt="UCARI Logo" width="100">
      </a>
    </div>

    <h1>Email Verified</h1>

    <p class="uk-margin">
      Your email has been verified. You can now sign in.
    </p>

    <router-link to="/login" class="uk-button uk-button-primary">
      Sign in
    </router-link>
  </div>
</template>

<script>
export default {
  created() {
    document.title = "Email Verified | UCARI";
  },
};
</script>